import { Stack, useLocalSearchParams } from 'expo-router'
import { useEffect } from 'react'
import { KeyboardAvoidingView, Platform } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import TableData from '@/modules/tableData/TableData'
import { fetchTableCoverThunk, selectTableCoverById } from '@/redux/slices/tableCoverSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import type { FormCoverFragment } from '@/typings/domain'

export default function TableDataPage() {
  const insets = useSafeAreaInsets()
  const { tableToken, ...searchParams } = useLocalSearchParams<{ tableToken: string }>()
  const dispatch = useAppDispatch()
  const headerLeftItems = useWebBackButton('/tables')

  const tableCover = useAppSelector(state => selectTableCoverById(state.tableCover, tableToken)) as
    | FormCoverFragment
    | undefined
  const tableName = tableCover?.subname || tableCover?.name

  useEffect(() => {
    if (!tableCover && tableToken) {
      dispatch(fetchTableCoverThunk({ tableToken }))
    }
  }, [dispatch, tableCover, tableToken])

  return (
    <KeyboardAvoidingView
      className="flex-1"
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
      style={Platform.OS === 'android' ? { paddingBottom: insets.bottom } : undefined}
    >
      <Stack.Screen
        options={{
          title: tableName ?? '',
          headerTransparent: false,
          ...buildScreenHeaderItems({
            left: headerLeftItems,
          }),
        }}
      />
      <TableData tableToken={tableToken} searchParams={searchParams as Record<string, string>} />
    </KeyboardAvoidingView>
  )
}
